import type MvInputParams from "models/MvInputParams";
import type MvAdressResult from "models/MvAddressResult";
import type { CountryCode } from "models/CountryCode";
import type { Option } from "react-multi-select-component";

export type RequestParams = Record<string, string | number | undefined>;

const optionsToString = (options?: Option[]) =>
    options?.map((option) => option.value).join("|");

export const buildNearbyAddressesQuery = (
    params: MvInputParams,
    address: MvAdressResult,
    countryCode?: CountryCode,
): RequestParams => {
    const query = {
        c: "objects",
        limit: 999999,
        latitude: address.breedtegraad,
        longitude: address.lengtegraad,
        priceFrom: params.houseValue ? params.houseValue[0] * 1000 : undefined,
        priceTo: params.houseValue ? params.houseValue[1] * 1000 : undefined,
        distance: params.radius! / 1000,
        countryCode: countryCode || "nl",
        houseType: optionsToString(params.houseType),
        buildingUsage: optionsToString(params.buildingUsage),
        buyRatio: optionsToString(params.buyRatio),
        buildYear: optionsToString(params.buildYear),
        buildingSize: optionsToString(params.buildingSize),
        livingArea: optionsToString(params.livingArea),
        residenceLength: optionsToString(params.residenceLength),
        purchasingPowerClass: optionsToString(params.purchasingPowerClass),
        rentOrBuy: params.housePriceType?.join("|"),
        household: params.household?.join("|"),
        streetName: params.streetName,
    };
    return Object.fromEntries(
        Object.entries(query).filter(
            ([, value]) =>
                value !== "" && value !== null && value !== undefined,
        ),
    );
};
